/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Service_OtherInputs */

const en_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something else`)
};

const ar_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موضوع آخر`)
};

const bn_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অন্য বিষয়`)
};

const de_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas anderes`)
};

const es_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro tema`)
};

const fr_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre sujet`)
};

const pt_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outro assunto`)
};

const zh_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他事项`)
};

const tr_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başka konu`)
};

const ru_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другой вопрос`)
};

const pl_form_service_other = /** @type {(inputs: Form_Service_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inny temat`)
};

/**
* | output |
* | --- |
* | "Something else" |
*
* @param {Form_Service_OtherInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_service_other = /** @type {((inputs?: Form_Service_OtherInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Service_OtherInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_service_other(inputs)
	if (locale === "bn") return bn_form_service_other(inputs)
	if (locale === "de") return de_form_service_other(inputs)
	if (locale === "es") return es_form_service_other(inputs)
	if (locale === "fr") return fr_form_service_other(inputs)
	if (locale === "pt") return pt_form_service_other(inputs)
	if (locale === "zh") return zh_form_service_other(inputs)
	if (locale === "tr") return tr_form_service_other(inputs)
	if (locale === "ru") return ru_form_service_other(inputs)
	if (locale === "pl") return pl_form_service_other(inputs)
	return en_form_service_other(inputs)
});